import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { DragDropModule } from 'primeng/dragdrop';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { environment } from '../environments/environment';
import { ErrorInterceptor } from './core/interceptors/error/error.interceptor';
import {
  AuthenticationEffects,
  CoreEffects,
  StoreChannelEffects,
  NotificationEffects,
  StateEffects,
} from './store/effects';
import { reducers, metaReducers } from './store/reducers';
import { NotificationComponent } from './shared/components/notification/notification.component';
import { TimeoutInterceptor } from '@core/interceptors/timeout.interceptor';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    AppLayoutModule,
    SharedModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([
      CoreEffects,
      NotificationEffects,
      AuthenticationEffects,
      StoreChannelEffects,
      StateEffects,
    ]),
    NotificationComponent,
    StoreRouterConnectingModule.forRoot(),
    DragDropModule,
    // Habilita Redux DevTools solo en modo de desarrollo
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Número de acciones a mantener en el historial
      logOnly: environment.production, // Solo permite logging si es producción
    }),
  ],
  providers: [
    NotificationComponent,
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor, // Usa useClass para un interceptor basado en clase
      multi: true, // Permite múltiples interceptores
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeoutInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
